"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

require("../styles/_inpiration-votes.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT_ARROW_COLOR = 'russian';
var ICON_SIZE = 18;
var UP_VOTE = 'UP_VOTE';
var DOWN_VOTE = 'DOWN_VOTE';

var getVoteNumberValue = function getVoteNumberValue(vote) {
  switch (vote) {
    case UP_VOTE:
      return 1;

    case DOWN_VOTE:
      return -1;

    default:
      return 0;
  }
};

var Votes = /*#__PURE__*/function (_Component) {
  _inherits(Votes, _Component);

  function Votes(_ref) {
    var _this;

    var upVotes = _ref.upVotes,
        downVotes = _ref.downVotes,
        currentUserVote = _ref.currentUserVote;

    _classCallCheck(this, Votes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Votes).call(this));

    _defineProperty(_assertThisInitialized(_this), "toggleVote", (0, _lodash.default)(function (vote) {
      return (/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
            var toggleVote, _ref3, data, error;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    toggleVote = _this.props.toggleVote;
                    _context.next = 5;
                    return toggleVote(vote);

                  case 5:
                    _ref3 = _context.sent;
                    data = _ref3.data;
                    error = _ref3.error;

                    if (!(!data || error || !data.toggleInspirationVote)) {
                      _context.next = 10;
                      break;
                    }

                    return _context.abrupt("return");

                  case 10:
                    _this.setState({
                      currentUserVote: data.toggleInspirationVote
                    });

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()
      );
    }));

    _this.state = {
      calculatedVotes: upVotes - downVotes - getVoteNumberValue(currentUserVote),
      currentUserVote: currentUserVote
    };
    return _this;
  }

  _createClass(Votes, [{
    key: "render",
    value: function render() {
      var hideTotal = this.props.hideTotal;
      var _this$state = this.state,
          calculatedVotes = _this$state.calculatedVotes,
          currentUserVote = _this$state.currentUserVote;
      var totalVotes = hideTotal ? 0 : calculatedVotes + getVoteNumberValue(currentUserVote); // The condition is to not render the component according to https://shootsta.atlassian.net/browse/HUB-1752

      /* eslint-disable-next-line no-constant-condition */

      if (true) return null;
      return _react.default.createElement("div", {
        className: "inspiration-votes"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "thumbup",
        size: ICON_SIZE,
        color: currentUserVote === UP_VOTE ? 'monkey' : DEFAULT_ARROW_COLOR,
        onClick: currentUserVote === UP_VOTE ? void 0 : this.toggleVote(UP_VOTE),
        hoverColor: "monkey"
      }), !hideTotal && _react.default.createElement("div", {
        className: "inspiration-votes__total"
      }, totalVotes), _react.default.createElement(_uiKit.Icon, {
        name: "thumbdown",
        size: ICON_SIZE,
        color: currentUserVote === DOWN_VOTE ? 'redApple' : DEFAULT_ARROW_COLOR,
        onClick: currentUserVote === DOWN_VOTE ? void 0 : this.toggleVote(DOWN_VOTE),
        hoverColor: "redApple"
      }));
    }
  }]);

  return Votes;
}(_react.Component);

exports.default = Votes;

_defineProperty(Votes, "defaultProps", {
  upVotes: 0,
  downVotes: 0,
  currentUserVote: void 0
});